import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Table } from 'antd';

import QartodLabel from '../QartodLabel';

const ParameterLog = (props) => {
  const {
    parameterObs, timestamps, displayName, displayUnit, qartodResults, getQartodResults,
  } = props;

  console.log('props', props);

  if (!parameterObs || parameterObs?.length === 0) {
    return null;
  }

  const rows = parameterObs
    .map((obs, index) => ({
      key: index,
      value: obs,
      timestamp: timestamps[index],
      qartod: qartodResults?.[index],
    }))
    .sort((a, b) => b.timestamp - a.timestamp);

  const handleRowClick = (record) => {
    getQartodResults(record.timestamp);
  };

  const columns = [
    {
      title: 'Time',
      dataIndex: 'timestamp',
      key: 'timestamp',
      render: (ts) => moment.unix(ts).format('MM/DD/YYYY hh:mm:ss A'),
    },
    {
      title: `${displayName} (${displayUnit})`,
      dataIndex: 'value',
      key: 'value',
    },
    {
      title: 'QARTOD',
      dataIndex: 'qartod',
      key: 'qartod',
      render: (qartod) => <QartodLabel result={qartod} />,
    },
  ];

  return (
    <div
      style={{
        // paddingLeft: 10,
      }}
    >
      <Table
        className="platform-dashboard-table"
        columns={columns}
        dataSource={rows}
        onRow={(record) => ({
          onClick: () => handleRowClick(record),
        })}
      />
    </div>
  );
};

ParameterLog.propTypes = {
  parameterObs: PropTypes.array,
  timestamps: PropTypes.array,
  displayName: PropTypes.string,
  displayUnit: PropTypes.string,
  qartodResults: PropTypes.array,
  getQartodResults: PropTypes.func,
};

ParameterLog.defaultProps = {
  parameterObs: undefined,
  timestamps: undefined,
  displayName: '',
  displayUnit: '',
  qartodResults: undefined,
  getQartodResults: () => {},
};

export default ParameterLog;
